export default {
  extension: {
    widgetLabel: {
      statistic: '统计数值',
      barChart: '柱状图',
      pieChart: '饼图',
      barXChart: '条形图',
      lineChart: "折线图",
      funnelChart: "漏斗图",
      progressbar: "进度条",
      radarChart: "雷达图",
      pivotTable: "透视表",
      listTable: "数据列表"
    },
    setting: {
      //
    }
  }
};